import {SyncedField} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/syncedfield';
import {SyncedFieldSetting} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/syncedfieldsetting';
import {Toggle} from '/ui/components/toggle/toggle';
import {Tooltip} from '/ui/components/tooltip/tooltip';

/**
 *
 * @param {{
 * syncedField: SyncedField,
 * syncedFieldSetting: SyncedFieldSetting,
 * setSyncedFieldSetting: Function
 * }} props
 * @returns
 */
export function OverwriteDataToggle({syncedField, syncedFieldSetting, setSyncedFieldSetting}) {
  if (!syncedField.canOverwriteData) {
    return '--';
  }

  return <Toggle
    checked={syncedFieldSetting.replaceExisting}
    value={syncedFieldSetting.replaceExisting}
    onChange={() => {
      const newSyncedFieldSetting = new SyncedFieldSetting({
        syncedFieldKey: syncedFieldSetting.syncedFieldKey,
        overrideFieldKey: syncedFieldSetting.overrideFieldKey,
        enabled: syncedFieldSetting.enabled,
        replaceExisting: !syncedFieldSetting.replaceExisting,
        applyToNewSubAccounts: syncedFieldSetting.applyToNewSubAccounts,
      });
      setSyncedFieldSetting(newSyncedFieldSetting);
    }}
  />;
}
